export const TaskResult: { value: string; text: string }[] = [
  { value: 'NotReceived', text: 'Не получен' },
  { value: 'Confirmed', text: 'Подтверждено' },
  { value: 'Cancelled', text: 'Отказ' },
  { value: 'Rescheduled', text: 'Запрос на перенос' },
  { value: 'CancelledByClinic', text: 'Отменено клиникой' },
  { value: 'RescheduledByClinic', text: 'Перенесено клиникой' },
  { value: 'NotIdentified', text: 'Не идентифицирован' },
  { value: 'Blocked', text: 'Черный список' },
  { value: 'OperatorHanded', text: 'Передано оператору' },
  { value: 'Failed', text: 'Не удалось дозвониться' },
];

export const TASK_RESULT_TEXT_MAP: Record<string, string> = TaskResult.reduce<
  Record<string, string>
>(
  (acc, item) => {
    acc[item.value] = item.text;
    return acc;
  },
  {
    Declined: 'Отказ',
    ClinicCancelled: 'Отменено клиникой',
    ClinicRescheduled: 'Перенесено клиникой',
    NeedOperator: 'Передано оператору',
    InvalidNumber: 'Невалидный номер',
  },
);

export const taskResultLabel = (value?: string | null): string => {
  if (!value) {
    return 'Неизвестно';
  }

  return TASK_RESULT_TEXT_MAP[value] ?? value;
};
